import React, { useState, useEffect } from 'react'
import RichText from '../../RichText'
import SkillBlockSkillContent from './SkillBlockSkillContent'
import Modal from 'react-modal'
import PrintSvg from '../../../images/printer.svg'

Modal.setAppElement('#root')

const SkillsBlock = (props) => {
  const { content, skills = [], printPdf } = props
  const [modalOpen, setModalOpen] = useState(false)
  const [modalContent, setModalContent] = useState({})
  const [currentIndex, setCurrentIndex] = useState(0)
  const [skillsLength, setSkillsLength] = useState(0)

  // Open Skills Modal
  const openModal = currentKey => {
    // getFlattenedEntries(skills).forEach(({ key, fields }, i) => {
    skills.forEach((skill, i) => {
      if (skill.id === currentKey) {
        setModalContent(skill)
        setCurrentIndex(i)
      }
    })
    setModalOpen(true)
  }

  // Close Skills Modal
  const closeModal = () => {
    setModalOpen(false)
  }

  // Get number of skills
  useEffect(() => {
    setSkillsLength(skills.length)
  }, [skills])

  // Set Current Modal Content
  useEffect(() => {
    skills.forEach((skill, i) => {
      if (i === currentIndex) {
        setModalContent(skill)
      }
    })
  }, [currentIndex, skills])

  // Go back to previous skill in modal
  const goBack = () => {
    if (currentIndex === 0) {
      setCurrentIndex(skillsLength - 1)
    } else {
      setCurrentIndex(currentIndex - 1)
    }
  }

  // Go to next skill in modal
  const goForward = () => {
    if (currentIndex < skillsLength - 1) {
      setCurrentIndex(currentIndex + 1)
    } else {
      setCurrentIndex(0)
    }
  }

  return (
    <div className="skills-block">
      <div className="skills-block-top">
        <RichText content={content} />
      </div>
      <div className="skills-block-modals">
        {skills.map((skill) => (
          <SkillBlockSkillContent
            key={skill.id}
            id={skill.id}
            openModal={openModal}
            {...skill}
          />
        ))}
      </div>

      {printPdf && (
        <div className="print-button">
          <a
            className="link"
            href={printPdf.file.url}
            rel="noreferrer noopener"
            target="_blank"
          >
            <svg alt="printer" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
            <g clip-path="url(#clip0_478_992)">
            <path d="M21 4.55H19.33V1.71C19.33 1.25821 19.1512 0.824771 18.8327 0.504369C18.5142 0.183968 18.0818 0.00264206 17.63 0H5.12C4.66729 0.00262447 4.23387 0.183627 3.91375 0.503747C3.59363 0.823868 3.41262 1.25729 3.41 1.71V4.55H1.71C1.25821 4.54999 0.824771 4.72878 0.504369 5.04731C0.183968 5.36583 0.00264206 5.79821 0 6.25L0 16.49C0.00264206 16.9418 0.183968 17.3742 0.504369 17.6927C0.824771 18.0112 1.25821 18.19 1.71 18.19H3.41V21C3.41264 21.4518 3.59397 21.8842 3.91437 22.2027C4.23477 22.5212 4.66821 22.7 5.12 22.7H17.63C18.0809 22.7 18.5133 22.5209 18.8321 22.2021C19.1509 21.8833 19.33 21.4509 19.33 21V18.19H21C21.4509 18.19 21.8833 18.0109 22.2021 17.6921C22.5209 17.3733 22.7 16.9409 22.7 16.49V6.25C22.7 5.79913 22.5209 5.36673 22.2021 5.04792C21.8833 4.72911 21.4509 4.55 21 4.55ZM4.55 1.71C4.54864 1.63477 4.56246 1.56004 4.59063 1.49028C4.61879 1.42051 4.66073 1.35713 4.71393 1.30393C4.76713 1.25073 4.83051 1.20879 4.90028 1.18063C4.97005 1.15246 5.04477 1.13864 5.12 1.14H17.63C17.7044 1.13999 17.778 1.1548 17.8466 1.18356C17.9152 1.21233 17.9774 1.25448 18.0296 1.30754C18.0817 1.3606 18.1227 1.42352 18.1503 1.49262C18.1778 1.56173 18.1913 1.63562 18.19 1.71V4.55H4.55V1.71ZM18.19 21C18.19 21.1495 18.1313 21.2929 18.0266 21.3996C17.9219 21.5062 17.7794 21.5674 17.63 21.57H5.12C4.96883 21.57 4.82384 21.5099 4.71695 21.4031C4.61005 21.2962 4.55 21.1512 4.55 21V13.65H18.19V21ZM21.61 16.45C21.6074 16.6004 21.5466 16.7439 21.4402 16.8502C21.3339 16.9566 21.1904 17.0174 21.04 17.02H19.33V13.65H19.9C20.0504 13.6474 20.1939 13.5865 20.3002 13.4802C20.4066 13.3739 20.4674 13.2304 20.47 13.08C20.47 12.9288 20.4099 12.7838 20.3031 12.6769C20.1962 12.5701 20.0512 12.51 19.9 12.51H2.84C2.68883 12.51 2.54384 12.5701 2.43695 12.6769C2.33005 12.7838 2.27 12.9288 2.27 13.08C2.27257 13.2304 2.33345 13.3739 2.43979 13.4802C2.54614 13.5865 2.68963 13.6474 2.84 13.65H3.41V17.06H1.71C1.55883 17.06 1.41384 16.9999 1.30695 16.8931C1.20005 16.7862 1.14 16.6412 1.14 16.49V6.25C1.13999 6.17561 1.1548 6.10196 1.18356 6.03336C1.21233 5.96476 1.25448 5.90258 1.30754 5.85044C1.3606 5.79831 1.42352 5.75727 1.49262 5.72972C1.56173 5.70218 1.63562 5.68867 1.71 5.69H21C21.1495 5.68998 21.2929 5.74866 21.3996 5.8534C21.5062 5.95814 21.5674 6.10057 21.57 6.25L21.61 16.45Z" fill="#141E28"/>
            <path d="M6.25018 15.92H16.4902C16.6413 15.92 16.7863 15.86 16.8932 15.7531C17.0001 15.6462 17.0602 15.5012 17.0602 15.35C17.0576 15.1997 16.9967 15.0562 16.8904 14.9498C16.784 14.8435 16.6405 14.7826 16.4902 14.78H6.25018C6.10074 14.7827 5.95832 14.8439 5.85357 14.9505C5.74883 15.0571 5.69015 15.2006 5.69018 15.35C5.68885 15.4244 5.70235 15.4983 5.7299 15.5674C5.75745 15.6365 5.79848 15.6994 5.85062 15.7525C5.90275 15.8056 5.96494 15.8477 6.03354 15.8765C6.10214 15.9052 6.17579 15.92 6.25018 15.92ZM6.25018 18.19H16.4902C16.5707 18.2008 16.6525 18.1942 16.7303 18.1707C16.808 18.1472 16.8799 18.1074 16.941 18.0539C17.0021 18.0004 17.0511 17.9344 17.0846 17.8605C17.1182 17.7865 17.1355 17.7062 17.1355 17.625C17.1355 17.5438 17.1182 17.4635 17.0846 17.3896C17.0511 17.3156 17.0021 17.2497 16.941 17.1962C16.8799 17.1427 16.808 17.1028 16.7303 17.0794C16.6525 17.0559 16.5707 17.0493 16.4902 17.06H6.25018C6.11326 17.0783 5.98764 17.1456 5.89665 17.2496C5.80566 17.3535 5.75551 17.4869 5.75551 17.625C5.75551 17.7632 5.80566 17.8966 5.89665 18.0005C5.98764 18.1044 6.11326 18.1718 6.25018 18.19ZM6.25018 20.47H16.4902C16.6413 20.47 16.7863 20.41 16.8932 20.3031C17.0001 20.1962 17.0602 20.0512 17.0602 19.9C17.0602 19.7489 17.0001 19.6039 16.8932 19.497C16.7863 19.3901 16.6413 19.33 16.4902 19.33H6.25018C6.099 19.33 5.95402 19.3901 5.84713 19.497C5.74023 19.6039 5.68018 19.7489 5.68018 19.9C5.68018 20.0512 5.74023 20.1962 5.84713 20.3031C5.95402 20.41 6.099 20.47 6.25018 20.47Z" fill="#141E28"/>
            </g>
            <defs>
            <clipPath id="clip0_478_992">
            <rect width="22.74" height="22.74" fill="white"/>
            </clipPath>
            </defs>
            </svg>
            Print
          </a>
        </div>
      )}

      <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        contentLabel="Skills Modal"
        className="modal skills-modal"
        overlayClassName="modal-overlay"
        shouldCloseOnOverlayClick={true}
      >
        <div className="modal-header">
          <button onClick={closeModal} className="close-modal">
            <svg xmlns="http://www.w3.org/2000/svg" width="18.1" height="17">
              <path
                d="M10.5 8.5l7.2-6.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L9 7.1 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4l7.2 6.8-7.2 6.8c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.2 0 .5-.1.7-.3L9 9.9l7.3 6.9c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-7.2-6.9z"
                fill="#131e29"
              />
            </svg>
            <span className="visually-hidden">close</span>
          </button>
        </div>

        <div className="modal-body">
          {modalContent.preTitle && (
            <p className="skill-header">{modalContent.preTitle}</p>
          )}
          {modalContent.content && <RichText content={modalContent.content} />}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="55.1"
            height="18.9"
            className="logo"
          >
            <path
              d="M.3 5.4c-.5-.6-.4-1.2.3-1.7L5.2.3c.6-.4 1.2-.4 1.7.2C8.2 2 9.6 3.4 11 4.7c1.4 1.2 2.9 2.3 4.6 3.2 1.7.9 3.5 1.5 5.4 2 1.9.5 4.1.7 6.6.7 2.4 0 4.6-.2 6.6-.6 2-.4 3.8-1 5.4-1.8 1.7-.8 3.2-1.8 4.6-3C45.6 3.9 47 2.5 48.3 1c.5-.6 1-.6 1.7-.2l4.5 3c.7.4.8 1 .4 1.7-3.2 4.6-7.1 8-11.7 10.2-4.6 2.2-9.7 3.3-15.5 3.3-5.8 0-11-1.1-15.5-3.3C7.5 13.4 3.6 10 .3 5.4z"
              fill="#ffa400"
            />
          </svg>
        </div>
        <button className="arrow-button back" onClick={goBack}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.5 32.8">
            <path d="M17.5 0c.3 0 .5.1.7.3.4.4.4 1 0 1.4L2.5 16.4l15.7 14.7c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L.3 17.1c-.2-.2-.3-.4-.3-.7s.1-.5.3-.7L16.8.3c.2-.2.4-.3.7-.3z" />
          </svg>
          <span className="visually-hidden">Previous Skill</span>
        </button>

        <button className="arrow-button next" onClick={goForward}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.5 32.8">
            <path d="M1 32.8c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L16 16.4.3 1.7C-.1 1.3-.1.7.3.3c.4-.4 1-.4 1.4 0l16.5 15.4c.2.2.3.5.3.7s-.1.5-.3.7L1.7 32.5c-.2.2-.5.3-.7.3z" />
          </svg>
          <span className="visually-hidden">Next Skill</span>
        </button>
      </Modal>
    </div>
  )
}

export default SkillsBlock
